import { render, staticRenderFns } from "./yqg-video.vue?vue&type=template&id=29ec037a&scoped=true&"
import script from "./yqg-video.vue?vue&type=script&lang=js&"
export * from "./yqg-video.vue?vue&type=script&lang=js&"
import style0 from "./yqg-video.vue?vue&type=style&index=0&id=29ec037a&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ec037a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ec037a')) {
      api.createRecord('29ec037a', component.options)
    } else {
      api.reload('29ec037a', component.options)
    }
    module.hot.accept("./yqg-video.vue?vue&type=template&id=29ec037a&scoped=true&", function () {
      api.rerender('29ec037a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/century-rongtai/index/component/yqg-video/yqg-video.vue"
export default component.exports